import { getFreshRestsList } from './getFreshRestsList/getFreshRestsList'
import { getRestsByContract } from './getRestsByContract/getRestsByContract'
import { restsBaseSelectors } from './restsBaseSelectors'

export const restsSelectors = {
  ...restsBaseSelectors,
  getFreshRestsList,
  getRestsByContract
}
